import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Injectable()
export class AdquirenciaService {

  getAdquirenciasPorContaCorrenteId(contaCorrenteId: number): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/adquirencia/visualizatodasporcontacorrente/' + contaCorrenteId, { observe: 'response' })
  }

  getAdquirenciaPorId(adquirenciaId: number): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/adquirencia/visualiza/' + adquirenciaId, { observe: 'response' })
  }

  deleteAdquirenciaPorId(adquirenciaId: number): Observable<HttpResponse<any>> {
    return this.http.delete(
      environment.webApiSaguiControlUrl + '/api/adquirencia/remove/' + adquirenciaId, { observe: 'response' })
  }

  postAdquirencia(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/adquirencia/inclui/', item, { observe: 'response' })
  }

  putAdquirencia(item: any, adquirenciaId: any): Observable<HttpResponse<any>> {
    return this.http.put(
      environment.webApiSaguiControlUrl + '/api/adquirencia/atualiza/' + adquirenciaId, item, { observe: 'response' })
  }

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {

  }
}
